import { I18n } from '@aws-amplify/core';

export default (curriculum) => (
    curriculum && `${curriculum.get('name')} (${curriculum.get('hoursMin') !== curriculum.get('hoursMax') ? `${curriculum.get('hoursMin')  }-` : ''}${curriculum.get('hoursMax')} ${I18n.get('hours')})`
);